import React from 'react';

import { Box, FormControlLabel, Stack, Switch } from '@mui/material';

import TogglePillGroup from '../shared/TogglePillGroup';

import { DisplaySortMode, HOTSPOT_RATIO_THRESHOLD, PERIOD_PRESETS, SORT_OPTIONS } from './constants';

interface Props {
  activePresetKey: string | null;
  onPeriodPresetChange: (days: number) => void;
  sort: DisplaySortMode;
  onSortChange: (sort: DisplaySortMode) => void;
  mixedSppOnly: boolean;
  onMixedSppOnlyChange: (checked: boolean) => void;
  hotspotsOnly: boolean;
  onHotspotsOnlyChange: (checked: boolean) => void;
}

export default function FilterControls({
  activePresetKey,
  onPeriodPresetChange,
  sort,
  onSortChange,
  mixedSppOnly,
  onMixedSppOnlyChange,
  hotspotsOnly,
  onHotspotsOnlyChange,
}: Props) {
  return (
    <Box sx={{ bgcolor: 'grey.100', borderRadius: 2, px: 2, py: 1.5, mb: 2 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 2, md: 4 }}
        alignItems={{ md: 'center' }}
        useFlexGap
        flexWrap="wrap"
      >
        <TogglePillGroup
          label="Period"
          ariaLabel="Quick range presets"
          options={PERIOD_PRESETS.map((preset) => ({ value: preset.key, label: preset.label }))}
          value={activePresetKey ?? ''}
          onChange={(key) => {
            const preset = PERIOD_PRESETS.find((p) => p.key === key);
            if (preset) {
              onPeriodPresetChange(preset.days);
            }
          }}
        />

        <TogglePillGroup<DisplaySortMode>
          label="Rank by"
          ariaLabel="rank properties by"
          options={SORT_OPTIONS}
          value={sort}
          onChange={onSortChange}
        />

        <FormControlLabel
          control={
            <Switch size="small" checked={mixedSppOnly} onChange={(e) => onMixedSppOnlyChange(e.target.checked)} />
          }
          label="Mixed SPP only"
          sx={{ '& .MuiFormControlLabel-label': { fontSize: 13, fontWeight: 600, color: 'text.primary' } }}
        />

        <FormControlLabel
          control={
            <Switch size="small" checked={hotspotsOnly} onChange={(e) => onHotspotsOnlyChange(e.target.checked)} />
          }
          label={`Hotspots only (< ${HOTSPOT_RATIO_THRESHOLD} ratio)`}
          sx={{ '& .MuiFormControlLabel-label': { fontSize: 13, fontWeight: 600, color: 'text.primary' } }}
        />
      </Stack>
    </Box>
  );
}
